<template>
    <div class="col-12 mx-auto">
        <div>
            <AnnualCatalogDetails>
            </AnnualCatalogDetails>
        </div>
        <div class="mt-5">
            <events-in-catalog-grid :showHideButton="showHideButton"
                                    :showPinButton="showPinButton"
                                    :showNewButton="showNewButton"
                                    :showResizeIcon="showResizeIcon"
                                    :size="size"
                                    :showSettingsBtn="showSettingsBtn"
                                    :showBtns="showBtns"
                                    :title="titleKey"
                                    :showImportFromExcelButton="true"
                                    :registerName="registerName"
                                    :annualId="annualId">
            </events-in-catalog-grid>
        </div>
        <div class="mt-5">
            <events-out-of-catalog-grid :showHideButton="showHideButton"
                         :showPinButton="showPinButton"
                         :showNewButton="showNewButton"
                         :showResizeIcon="showResizeIcon"
                         :size="size"
                         :showSettingsBtn="showSettingsBtn"
                         :showBtns="showBtns"
                         :title="titleKey"
                         :showImportFromExcelButton="true"
                         :registerName="registerName"
                         :annualId="annualId">
            </events-out-of-catalog-grid>
        </div>
        <page-title :title="$t('annualCatalog.annualCatalog')" :showTitle="false"></page-title>
    </div>
</template>

<script>
    import AnnualCatalogDetails from '../../views/AnnualCatalog/AnnualCatalogDetails.vue'
    import EventsOutOfCatalogGrid from "../../components/dynamic/events/EventsOutOfAnnualCatalogGrid"
    import EventsInCatalogGrid from "../../components/dynamic/events/EventsInAnnualCatalogGrid"
    import PageTitle from '../../components/common/PageTitle';

    export default {
        components: {
            AnnualCatalogDetails,
            EventsInCatalogGrid,
            EventsOutOfCatalogGrid,
            PageTitle
        },
        props: {
            // Пропъртита, които трабват на компонента с бутоните за дашборд настройките
            registerName: {
                default: '',
                type: String
            },
            // Пропъртита, които трабват на компонента с бутоните за дашборд настройките
            showHideButton: {
                default: false,
                type: Boolean
            },
            showPinButton: {
                default: false,
                type: Boolean
            },
            showNewButton: {
                default: false,
                type: Boolean
            },
            showResizeIcon: {
                default: false,
                type: Boolean
            },
            size: {
                default: 6,
                type: Number
            },
            showBtns: {
                default: false,
                type: Boolean
            },
            showSettingsBtn: {
                default: false,
                type: Boolean
            }
        },
        data() {
            return {
                titleKey: 'registers.' + this.registerName + '.title', // Трабва на конпонентата за бутоните за дашборд настройките
                annualId: ''
            }
        },
        mounted() {
            this.annualId = this.$route.params.id;
        },
        computed: {
            token: function () {
                return this.$store.getters.authToken;
            },
            isEnVersion() {
                return this.$store.getters.currentCulture === 'en';
            }
        }
    }
</script>

<style>

</style>

